import { VIcon } from 'vuetify/lib/components/VIcon';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breadcrumb",class:{raw: _vm.raw}},[_vm._l((_vm.items),function(item,i){return [_c('router-link',{directives:[{def: Ripple,name:"ripple",rawName:"v-ripple"}],key:item.name,staticClass:"item",attrs:{"to":item.link}},[_vm._v(_vm._s(item.name))]),(i < _vm.items.length - 1)?_c(VIcon,{key:i},[_vm._v("mdi-chevron-right")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }